/** Keep IMEI API model in sync with catalog dropdown (avoid iPhone 17 → 15 Pro). */

export function normalizeModelLabel(name: string): string {
  return name
    .replace(/\s*\([A-Z0-9]{3,8}\)\s*$/i, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
}

export function modelGenerations(name: string): number[] {
  const out: number[] = []
  const re = /\b(1[0-9]|2[0-9])\b/g
  let m: RegExpExecArray | null
  while ((m = re.exec(name.toLowerCase())) !== null) {
    const n = Number(m[1])
    if (n >= 10 && n <= 29) out.push(n)
  }
  return out
}

export function modelsRoughlyMatch(apiModel: string, catalogModel: string): boolean {
  const api = normalizeModelLabel(apiModel)
  const cat = normalizeModelLabel(catalogModel)
  if (!api || !cat) return false

  const ag = modelGenerations(api)
  const cg = modelGenerations(cat)
  if (ag.length && cg.length && !ag.some((x) => cg.includes(x))) return false

  if (api.includes('max') && !cat.includes('max')) return false
  if (api.includes('mini') && !cat.includes('mini')) return false
  if (api.includes('plus') && !cat.includes('plus')) return false

  return api === cat || api.includes(cat) || cat.includes(api)
}

export interface PhoneModelPick {
  id: number
  manufacturer: string
  model_name: string
  hero_image_path?: string | null
  release_year?: number | null
}

export function resolvePhoneModelIdFromHints(
  models: PhoneModelPick[],
  hints: { phone_model_id?: number | null; brand?: string | null; model_name?: string | null },
): string {
  const brand = (hints.brand || '').trim().toLowerCase()
  const apiModel = (hints.model_name || '').trim()

  if (apiModel && brand) {
    const exact = models.find(
      (m) =>
        m.manufacturer.toLowerCase() === brand &&
        modelsRoughlyMatch(apiModel, m.model_name),
    )
    if (exact) return String(exact.id)
  }

  if (hints.phone_model_id != null) {
    const byId = models.find((m) => m.id === hints.phone_model_id)
    if (byId && (!apiModel || modelsRoughlyMatch(apiModel, byId.model_name))) {
      return String(byId.id)
    }
  }

  return ''
}
